import React from "react";
import styles from "./Sidebar.module.css";

export default function Sidebar({
    title = "Data management",
    endpoints = [],
    activePath,
    LinkComponent,
    onRequestClose,
}) {
    return (
        <nav className={styles.panel} aria-label={title}>
            <div className={styles.header}>
                <h3 className={styles.title}>{title}</h3>
                {onRequestClose && (
                    <button
                        className={styles.closeBtn}
                        aria-label="Close menu"
                        onClick={onRequestClose}
                    >
                        ×
                    </button>
                )}
            </div>

            {/* edge-to-edge blue separator under the title */}
            <div className={styles.rule} aria-hidden="true" />

            <ul className={styles.list}>
                {endpoints.map(({ to, label }) => {
                    const isActive =
                        activePath && (activePath === to || activePath.startsWith(to + "/"));
                    const className = `${styles.link} ${isActive ? styles.active : ""}`;
                    return (
                        <li key={to}>
                            {LinkComponent ? (
                                <LinkComponent
                                    to={to}
                                    className={className}
                                    aria-current={isActive ? "page" : undefined}
                                >
                                    <span className={styles.linkLabel}>{label}</span>
                                </LinkComponent>
                            ) : (
                                <a
                                    href={to}
                                    className={className}
                                    aria-current={isActive ? "page" : undefined}
                                >
                                    <span className={styles.linkLabel}>{label}</span>
                                </a>
                            )}
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
}
